import React, { useState, useEffect } from "react";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import image1 from "../Images/Mr.Olive/GreenOlive/زيتون أخضر بيكوال مخلي.jpg";
import image2 from "../Images/Mr.Olive/GreenOlive/زيتون منزانلو أخضر مخلي.jpg";
import image3 from "../Images/Mr.Olive/GreenOlive/عجيزي مخلي 4.jpg";

import image4 from "../Images/Mr.Olive/mix/زيتون مشوي.jpg";
import contact from "../Images/Group-of-customer-service-representatives.jpg";

export default function SubCategory2Spain() {
  const [currID, setCurrID] = useState("");
  const [loading, setLoading] = useState(false);
  const [productName, setProductName] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  async function sendQuote(e) {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        `https://mrolive-back-end-2c3o.onrender.com/api/v1/quote`,
        {
          name: name,
          email: email,
          productName: productName,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success(response?.data?.msg);
        setName("");
        setEmail("");
        document.getElementById("name").value = "";
        document.getElementById("email").value = "";
      })
      .catch((e) => {
        toast.error(e?.data?.msg);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  let imgList = Array.from(document.getElementsByClassName("imgItem"));
  let lightContainer = document.querySelector(".lightContainer");
  let lightBox = document.querySelector(".lightBox");
  let currentIndex = 0;

  let tmp = [
    {
      id: "1",
      text: (
        <p>
          Esta variedad es de origen español, y esta variedad ha logrado un gran
          éxito en su cultivo en Egipto. Este tipo es el más extendido en Egipto
          después de la aceituna verde Al-Ajizi debido a la diversidad de su uso
          y su cultivo se concentra en la zona de la Carretera del Desierto de
          Ismailia y la Carretera del Desierto de Alejandría. Este se distingue
          por su sabor especial porque contiene un alto porcentaje de aceite.
          Esta variedad es tratada en nuestra fábrica a la manera española y el
          método tradicional (agua y sal), que es el tratamiento de aceitunas
          preparadas para la oxidación. También lo fabricamos y lo dividimos en
          varios tipos:
          <br />
          1. Aceitunas verdes enteras Picual <br />
          2. Aceitunas verdes Picual en escabeche <br />
          3. Aceitunas verdes Picual en rodajas
        </p>
      ),
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>Descripción del artículo</th>
              <th>Tamaño(Normas griegas)</th>
              <th>Trozos de aceitunas/KG(Estándar español)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowSpan="12">Aceitunas verdes Picual</th>
              <td> Gigantes </td>
              <td>141-160</td>
            </tr>
            <tr>
              <td> Extra Jumbo</td>
              <td> 161-180</td>
            </tr>
            <tr>
              <td> Jumbo</td>
              <td>181-200</td>
            </tr>
            <tr>
              <td> Extra Grande</td>
              <td>201-230</td>
            </tr>
            <tr>
              <td>Grande</td>
              <td>231-260</td>
            </tr>
            <tr>
              <td> Superior</td>
              <td> 261-290</td>
            </tr>
            <tr>
              <td>Brillante</td>
              <td>291-320</td>
            </tr>
            <tr>
              <td>Multa</td>
              <td> 321-350</td>
            </tr>
            <tr>
              <td>Balas</td>
              <td> 351-380</td>
            </tr>
            <tr>
              <td> </td>
              <td> 381-420</td>
            </tr>
            <tr>
              <td></td>
              <td> 421-450</td>
            </tr>

            <tr>
              <td></td>
              <td> 451-500</td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "2",
      text: (
        <p>
          Aceituna Manzanilla Verde Esta variedad es de origen español, y esta
          variedad ha logrado un gran éxito en su cultivo en Egipto debido a la
          diversidad de su uso y su cultivo se concentra en la zona de la
          Carretera del Desierto de Ismailia y la Carretera del Desierto de
          Alejandría. Esta variedad se distingue por su sabor especial porque
          contiene un alto porcentaje de aceite. Esta variedad se trata a la
          manera española y el método tradicional (agua y sal), que es el
          tratamiento de aceitunas preparadas para la oxidación. También lo
          fabricamos y lo dividimos en varios tipos:
          <br />
          1. Aceitunas Manzanilla Verdes Enteras <br />
          2. Aceitunas manzanilla verdes sin hueso
          <br />
          3. Aceitunas manzanilla verdes en rodajas
        </p>
      ),
      table: (
        <table class="  table-bordered ">
          <thead>
            <tr>
              <th>Descripción del artículo</th>
              <th>Tamaño(Normas griegas)</th>
              <th>Trozos de aceitunas/KG(Estándar español)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th rowSpan="12">Aceitunas Manzanilla Verdes</th>
              <td> Gigantes </td>
              <td>141-160</td>
            </tr>
            <tr>
              <td> Extra Jumbo</td>
              <td> 161-180</td>
            </tr>
            <tr>
              <td> Jumbo</td>
              <td>181-200</td>
            </tr>
            <tr>
              <td> Extra Grande</td>
              <td>201-230</td>
            </tr>
            <tr>
              <td>Grande</td>
              <td>231-260</td>
            </tr>
            <tr>
              <td> Superior</td>
              <td> 261-290</td>
            </tr>
            <tr>
              <td>Brillante</td>
              <td>291-320</td>
            </tr>
            <tr>
              <td>Multa</td>
              <td> 321-350</td>
            </tr>
            <tr>
              <td>Balas</td>
              <td> 351-380</td>
            </tr>
            <tr>
              <td> </td>
              <td> 381-420</td>
            </tr>
            <tr>
              <td></td>
              <td> 421-450</td>
            </tr>

            <tr>
              <td></td>
              <td> 451-500</td>
            </tr>
          </tbody>
        </table>
      ),
    },
    {
      id: "3",
      text: (
        <p>
          Esta variedad es de origen egipcio y su cultivo se concentra en la
          zona de Fayoum y la carretera del desierto de Alejandría. Esta
          variedad se caracteriza por sus altos volúmenes que se requieren
          constantemente en los mercados globales. Esta variedad se trata a la
          manera española y el método tradicional (agua y sal), que es el
          tratamiento de aceitunas preparadas para la oxidación. También lo
          fabricamos y lo dividimos en varios tipos:
          <br />
          1. Aceitunas enteras envejecidas en verde <br />
          2. Aceitunas verdes deshuesadas envejecidas <br />
          3. Aceitunas verdes envejecidas en rodajas
          <br />
          4. Aceitunas verdes semielaboradas
        </p>
      ),
    },
    {
      id: "4",
      text: (
        <p>
          Esta variedad es de origen egipcio y su cultivo se concentra en la
          zona de Fayoum y la carretera del desierto de Alejandría. Esta
          variedad se caracteriza por sus altos volúmenes que se requieren
          constantemente en los mercados globales. Esta variedad se trata a la
          manera española y el método tradicional (agua y sal), que es el
          tratamiento de aceitunas preparadas para la oxidación. También lo
          fabricamos y lo dividimos en varios tipos: <br />
          1. Aceitunas enteras envejecidas en verde <br />
          2. Aceitunas verdes deshuesadas envejecidas <br />
          3. Aceitunas verdes envejecidas en rodajas
          <br />
          4. Aceitunas verdes semielaboradas
        </p>
      ),
    },
  ];

  function showImage(x) {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-none", "d-flex");
    document.querySelector(".very").style.backgroundImage = `url(${x.src})`;
    document.querySelector(".productName").innerHTML = x.name;
    currentIndex = x.id;
    setCurrID(currentIndex);
  }

  function closeSlide() {
    document
      .querySelector(".lightContainer2")
      .classList.replace("d-flex", "d-none");
  }
  function showForm() {
    document
      .querySelector(".showForm")
      .classList.replace("d-none", "d-inline-block");
  }

  return (
    <>
      <ToastContainer />

      <div className="products " onClick={closeSlide}></div>
      <div className="container p-4">
        <div className="row p-3">
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="1"
                src={image1}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceitunas verdes Picual");
                }}
                alt="image not found"
                className="photo"
                name="Aceitunas verdes Picual"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceitunas verdes Picual
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="2"
                src={image2}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceitunas Manzanilla Verdes");
                }}
                alt="image not found"
                className="photo"
                name="Aceitunas Manzanilla Verdes"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceitunas Manzanilla Verdes
            </p>
          </div>
          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="3"
                src={image3}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("Aceituna verde azizi");
                }}
                alt="image not found"
                className="photo"
                name="Aceituna verde azizi"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              Aceituna verde azizi
            </p>
          </div>

          <div className="col-md-4 photoContainer2">
            <div className="  imgItem">
              <img
                id="4"
                src={image4}
                onClick={(e) => {
                  showImage(e.target);
                  setProductName("aceitunas a la parrilla");
                }}
                alt="image not found"
                className="photo"
                name="aceitunas a la parrilla"
              />
            </div>
            <p style={{ color: "#4e732c", textAlign: "center" }}>
              aceitunas a la parrilla
            </p>
          </div>
        </div>
      </div>
      <div className="lightContainer2 d-none  align-items-center">
        <div className="lightBox2  ">
          <div className="container">
            <div className="row d-flex justify-content-center ">
              <div className="ayhaga" style={{ marginTop: "30px" }}>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <img className=" very" alt="" style={{ padding: "0" }} />
                </div>
                <h4
                  className="productName"
                  style={{
                    color: "#4e732c",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></h4>
                {tmp.map((each) => {
                  if (each.id === currID) {
                    return (
                      <div>
                        <p style={{ color: "white" }}> {each.text} </p>
                        <div>{each.table}</div>
                      </div>
                    );
                  }
                })}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    margin: "10px",
                  }}
                >
                  <button
                    className="btn get bgDark"
                    style={{ marginBottom: "5px" }}
                    onClick={showForm}
                  >
                    Obtener cotización
                  </button>
                </div>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <form onSubmit={sendQuote}>
                    <div className="showForm d-none ">
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        placeholder="Introduzca su nombre"
                        style={{ marginBottom: "5px" }}
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <input
                        type="email"
                        className="form-control"
                        // id="exampleFormControlInput2"
                        id="email"
                        placeholder="Introduce tu correo electrónico"
                        onChange={(e) => {
                          setEmail(e.target.value);
                        }}
                      />
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          margin: "10px",
                        }}
                      >
                        <button
                          className="btn get"
                          style={{ marginTop: "5px" }}
                          type="submit"
                        >
                          {loading ? (
                            <i className="fa-solid fa-spinner fa-spin"></i>
                          ) : (
                            "Enviar"
                          )}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>

          {/* <img src={image1} alt="image not found" className='lightBox'/> */}

          <i
            style={{
              color: "black",
              backgroundColor: "white",
              padding: "10px",
              borderRadius: "10px",
            }}
            id="close"
            className="fa-solid fa-xmark"
            onClick={closeSlide}
          ></i>
        </div>
      </div>
      <div
        className="row"
        style={{
          backgroundColor: "#4e732c",
          color: "white",
          margin: "0",
          display: "flex",
          justifyContent: "end",
        }}
      >
        <div className="col-md-7 col-sm-8" style={{ marginTop: "25px" }}>
          <div className="container">
            <div className="row ">
              <div
                className="col-md-12"
                style={{ display: "flex", justifyContent: "center" }}
              >
                <div className="contactContect">
                  <h6> contáctenos</h6>

                  <p>cuando tienes una pregunta estamos aquí para ayudarte</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-1 col-sm-4"
          style={{ backgroundColor: "#4e732c" }}
        ></div>
        <div className="col-md-4 col-sm-12 " style={{ padding: "0" }}>
          <img src={contact} alt="" className="contactMeFooter" />
        </div>
      </div>
    </>
  );
}
